import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
const PhoneVerification = () =>
  import("@src/components/PhoneVerification/PhoneVerification.vue");
const Test = () => import("@src/components/Test/Test.component.vue");
const SbpDemo = () =>
  import("@src/components/PaymentDemo/sbp/SbpDemo.component.vue");
const TinkoffPayDemo = () =>
  import("@src/components/PaymentDemo/tpay/TinkoffPayDemo.component.vue");
const SberPayDemo = () =>
  import("@src/components/PaymentDemo/sberpay/SberPayDemo.component.vue");
const ForeignCardDemo = () =>
  import(
    "@src/components/PaymentDemo/foreigncard/ForeignCardDemo.component.vue"
  );

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: PhoneVerification,
  },
  {
    path: "/test-get",
    name: "Test",
    component: Test,
  },
  {
    path: "/sbp/test/:id",
    name: "SBP",
    component: SbpDemo,
  },
  {
    path: "/tinkoffpay/test/:id",
    name: "TinkoffPay",
    component: TinkoffPayDemo,
  },
  {
    path: "/sberpay/test/:id",
    name: "SberPay",
    component: SberPayDemo,
  },
  {
    path: "/foreigncard/test/:id",
    name: "ForeignCard",
    component: ForeignCardDemo,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
